import DiscountExamine from './table.vue';

export default DiscountExamine;
